<template>
  <v-app>
    <div
      v-if="showNotification || showUnpaidSubscriptionNotification"
      class="show-unreported-appontments-notification"
    >
      <div>
        {{
          showUnpaidSubscriptionNotification
            ? "Molimo vas da izmirite vaše obaveze prema školi."
            : "Neki izvještaji nisu popunjeni već 7 dana. Molimo Vas da ih popunite."
        }}
      </div>
      <div
        v-if="showNotification"
        class="fill-appointments"
        @click="goToProfile"
      >Popuni izještaje</div>
      <img
        @click="() => closeNotification()"
        class="close-btn"
        src="./assets/icons/close-white.png"
        alt="Close"
      />
    </div>
    <div>
      <!-- <login></login> -->
      <router-view></router-view>
    </div>
  </v-app>
</template>

<script>
import Login from "./components/Login";
export default {
  components: {
    login: Login,
  },
  created() {
    let userVersion = localStorage.getItem("app-version");
    let packageJsonVersion = process.env.VERSION;
    if (userVersion !== packageJsonVersion) {
      localStorage.setItem("app-version", packageJsonVersion);
      location.reload(true);
    }
  },
  methods: {
    closeNotification() {
      this.$store.dispatch("setShowNotification", false);
      this.$store.dispatch("setShowUnpaidSubscriptionNotification", false);
    },
    goToProfile() {
      this.closeNotification();
      this.$router.push("/Home/Profile");
    },
  },
  computed: {
    showNotification() {
      return this.$store.getters.showNotification;
    },
    showUnpaidSubscriptionNotification() {
      return this.$store.getters.showUnpaidSubscriptionNotification;
    },
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}
/* GLOBAL STYLE */
.v-dialog {
  border-radius: 20px;
}
.v-overlay {
  z-index: 100 !important;
}
.v-menu__content {
  z-index: 1000 !important;
}
.close-icon {
  width: 30px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  z-index: 2;
}
.clearAfterFloats::after {
  content: "";
  display: block;
  clear: both;
}
.left {
  float: left;
}
.pointer {
  cursor: pointer;
}
.text-right {
  text-align: right;
}
.text-left {
  text-align: left;
}
.float-right {
  float: right;
}
.text-center {
  text-align: center;
}
.loading-icon {
  width: 35px;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}

/* TOGGLE BUTTONS */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* END OF TOGGLE BUTTONS */

.pagination {
  position: absolute;
  bottom: 0;
  margin: 30px 0;
  width: 100%;
}

/* PAGES HEADER */
.page-header {
  position: relative;
  margin-bottom: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-part {
  width: 33.3333333%;
}
.header-center {
  text-align: center;
}
.header-right {
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.header-text {
  font-size: 28px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #657786;
}
.header-text span {
  display: inline-block;
}
.header-text-line {
  width: 65%;
  height: 2px;
  border-radius: 200px;
  background-color: #039be5;
}

/* END OF PAGES HEADER */
.action-icon-lg {
  width: 35px;
  cursor: pointer;
  margin: 0 10px;
}
.action-icon-sm {
  width: 25px;
  cursor: pointer;
  margin: 5px 10px;
}
.clear-filter {
  position: fixed;
  background-color: #e74c3c;
  padding: 5px 10px;
  cursor: pointer;
  color: white;
  font-weight: 400;
  border-radius: 5px;
  font-size: 18px;
  bottom: 20px;
  left: 20px;
  z-index: 2;
}
.main-btn {
  display: inline-block;
  cursor: pointer;
  padding: 8px 30px !important;
  background-color: #039be5 !important;
  color: white !important;
  font-weight: 400;
  border-radius: 20px !important;
  transition: all 0.3s !important;
  text-transform: capitalize !important;
  font-size: 16px;
  height: auto !important;
  font-family: "Roboto" "sans-serif" !important;
}
.main-btn:hover {
  background-color: #23a9ea;
}
.form {
  margin-top: 20px;
}

.one-day-overdue {
  background-color: rgba(255, 204, 0, 0.35);
}
.five-days-overdue {
  background-color: rgba(255, 153, 102, 0.35);
}
.seven-days-overdue {
  background-color: rgba(204, 51, 0, 0.5);
}

.show-unreported-appontments-notification {
  position: fixed;
  top: 64px;
  left: 0;
  width: 100%;
  background-color: rgba(204, 51, 0, 1);
  color: white;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  z-index: 1000;
}

.show-unreported-appontments-notification .close-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 25px;
  cursor: pointer;
  width: 25px;
}
.fill-appointments {
  font-size: 16px;
  cursor: pointer;
}
.fill-appointments:hover {
  text-decoration: underline;
}
.appointment {
  cursor: pointer;
}

/* TIME PICKER */
@media (max-width: 768px) {
  .time-picker input.display-time {
    width: 100% !important;
  }
}
</style>
